export default {"src":"/_next/static/media/hashicorp-horizontal_on-dark.ce78369a.svg","height":62,"width":254,"blurWidth":0,"blurHeight":0};